import { gql } from '@apollo/client';
import { CORE_COMPANY_FIELDS } from './fragments/company';

export const GET_COMPANY_QUERY = gql`
    ${CORE_COMPANY_FIELDS}
    query Company($id: ID!) {
        node(id: $id) {
            ... on Company {
                ...CoreCompanyFields
            }
        }
    }
`;

export const SAVED_COMPANIES_QUERY = gql`
    query getSavedCompanies {
        companies {
            id
            recordId
            name
            status
            logoUrl
            addresses {
                purpose
                address
                address2
                address3
                city
                stateProvince
                country
                preferredBilling
                preferredMailing
            }
            primaryBusinessType {
                name
            }
        }
    }
`;

export const SAVE_COMPANY = gql`
    mutation SaveCompany($recordId: Int!) {
        saveCompany(recordId: $recordId) {
            company {
                recordId
            }
        }
    }
`;

export const UPDATE_COMPANY = gql`
    mutation UpdateCompany(
        $description: String
        $website: String
        $phone: String
        $linkedinUrl: String
        $twitterUrl: String
        $mainAddress: AddressInput
        $primaryBusinessType: PrimaryBusinessType
        $secondaryBusinessTypes: [SecondaryBusinessType]
        $minorityOwned: Boolean
        $womanOwned: Boolean
    ) {
        updateCompany(
            description: $description
            website: $website
            phone: $phone
            linkedinUrl: $linkedinUrl
            twitterUrl: $twitterUrl
            mainAddress: $mainAddress
            primaryBusinessType: $primaryBusinessType
            secondaryBusinessTypes: $secondaryBusinessTypes
            minorityOwned: $minorityOwned
            womanOwned: $womanOwned
        ) {
            id
            recordId
            description
            website
            linkedinUrl
            twitterUrl
            addresses {
                purpose
                address
                address2
                address3
                city
                stateProvince
                country
                preferredBilling
                preferredMailing
            }
            primaryBusinessType {
                code
                name
            }
            secondaryBusinessTypes {
                code
                name
            }
            minorityOwned
            womanOwned
        }
    }
`;

export const REMOVE_COMPANY = gql`
    mutation RemoveCompany($recordId: Int!) {
        removeCompany(recordId: $recordId) {
            company {
                recordId
            }
        }
    }
`;

export const GET_COMPANIES_FOR_SEARCH = gql`
    query getCompanies {
        companies {
            id
            recordId
            name
            status
            logoUrl
            addresses(purpose: [MAIN]) {
                country
                address
                address2
                address3
                city
                stateProvince
                zip
                purpose
                preferredBilling
                preferredMailing
            }
            primaryBusinessType {
                name
            }
            secondaryBusinessTypes {
                name
            }
        }
    }
`;

export const UPDATE_COMPANY_LOGO = gql`
    mutation UpdateCompanyLogo {
        updateCompanyLogo {
            file
            url
            uploadUrl
        }
    }
`;
